import type { IRequest } from 'legacy/lut/classes/models/onboarding/IRequest'

type BusinessModelRequest = Pick<IRequest, 'MainParameter' | 'Parent' | 'ParentSpec'>

const CONTRACT_CODES = ['PATSY-P1_T2-Reseller', 'PATSY-ST_T2-Retailer']
const SPECIALIZATION_CODES = [
  'PM_AMP_SYNERGY',
  'PA_AMP_PRINT_sMPS',
  'PA_AMP_COMM_MCS',
  'SPEC_AMP_SOFTWARE',
  'SPEC_AMP_RPOS',
  'SPEC_AMP_WKSTSOL',
  'SPEC_AMP_EDUCATION',
  'SPEC_AMP_SITEPR',
  'SPEC_AMP_LFDS',
  'SPEC_AMP_PTS',
  'SPEC_AMP_POLY',
]

// Portal mapping lives in onboarding's portalIntegration/helpers/PartnershipDataConverter.ts.
export const PRIMARY_BUSINESS_MODEL_OPTIONS = [
  { label: 'Auction House', key: 'AuctionHouse' },
  { label: 'Computer Rental/Leasing', key: 'ComputerRentalLeasing' },
  { label: 'Consultant', key: 'Consultant' },
  { label: 'Dealer', key: 'Dealer' },
  { label: 'Group Purchasing Organization', key: 'GroupPurchasingOrganization' },
  { label: 'Hardware Broker/Liquidator', key: 'HardwareBrokerLiquidator' },
  { label: 'Hardware Manufacturing (white box, BTO)', key: 'BTO' },
  { label: 'Hardware Vendor', key: 'HardwareVendor' },
  { label: 'Internet Reseller', key: 'InternetReseller' },
  { label: 'International Export/Freight Forwarders', key: 'InternationalExportFreightForwarders' },
  { label: 'Maintenance and Repair Service', key: 'MaintenanceRepairService' },
  { label: 'Networking Reseller', key: 'NetworkingReseller' },
  { label: 'Original Equipment Manufacturer (OEM)', key: 'OEM' },
  { label: 'Retailer', key: 'Retailer' },
  { label: 'Small-Business Reseller', key: 'SmallBusinessReseller' },
  { label: 'Software Developer', key: 'SoftwareDeveloper' },
  { label: 'System Integrator', key: 'SystemIntegrator' },
  { label: 'Value Added Reseller (VAR)', key: 'VAR' },
]

export const UPDATED_PRIMARY_BUSINESS_MODEL_OPTIONS = [
  { label: 'Poly Only', key: 'PolyOnly' },
  { label: 'Hardware Vendor', key: 'HardwareVendor' },
  { label: 'Internet Reseller', key: 'InternetReseller' },
  { label: 'Maintenance and Repair Service', key: 'MaintenanceRepairService' },
  { label: 'OEM', key: 'OEM' },
  { label: 'Retailer', key: 'Retailer' },
  { label: 'Small – Business Reseller', key: 'SmallBusinessReseller' },
  { label: 'Value Added Reseller VAR', key: 'VAR' },
]

const hasPrimaryBusinessModelCode = (code: string) =>
  CONTRACT_CODES.includes(code) || SPECIALIZATION_CODES.includes(code)

// RequestDetailView exposes the immediate parent's MainParameter as ParentSpec.
// Match the request that owns the form (the same RequestId used by server validation).
export const usesUpdatedPrimaryBusinessModel = (request?: BusinessModelRequest): boolean =>
  Boolean(
    request &&
      (hasPrimaryBusinessModelCode(request.MainParameter) ||
        (request.Parent && hasPrimaryBusinessModelCode(request.ParentSpec)))
  )
